<template>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    :scroll="{ x: 1530 }"
    :pagination="false"
    @resizeColumn="handleResizeColumn"
    class="mb40"
  >
    <template #status="{record}">
      <span>{{ record.status - 0 ? '启用' : '禁用' }}</span>
    </template>
    <template #deal="{record, text}">
      <a-button
        type="link"
        @click="
          () =>
            voteVisibleChange(true, {
              ...record,
              status: record.status - 0 === 1 ? true : false
            })
        "
        >编辑</a-button
      >
      <a-button
        type="link"
        @click="
          jumpPage('VoteInnerList', { ...text, ...searchParams, ...record })
        "
        >详情</a-button
      >
    </template>
  </a-table>
</template>
<script>
import { inject, toRefs, ref } from 'vue'
export default {
  setup() {
    const columns = ref([
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        resizable: true,
        width: 50,
        align: 'center'
      },
      {
        title: '投票名称',
        dataIndex: 'name',
        key: 'name',
        width: 150,
        resizable: true,
        align: 'center'
      },
      {
        title: '主标题',
        dataIndex: 'title',
        key: 'title',
        resizable: true,
        align: 'center',
        width: 180
      },
      {
        title: '子标题',
        dataIndex: 'subTitle',
        key: 'subTitle',
        resizable: true,
        align: 'center',
        width: 180
      },
      {
        title: 'url链接',
        dataIndex: 'url',
        key: 'url',
        resizable: true,
        align: 'center',
        width: 120
      },
      {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        slots: { customRender: 'status' },
        align: 'center',
        width: 50
      },
      {
        title: '操作',
        slots: { customRender: 'deal' },
        key: 'deal',
        fixed: 'right',
        align: 'center',
        width: 100
      }
    ])
    return {
      handleResizeColumn: (w, col) => {
        col.width = w
      },
      columns,
      ...toRefs(inject('initState'))
    }
  }
}
</script>
